// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/stem/stem-banner-maritus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/images/stem/STEM-Shop-mobile.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stem-banner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  height: 33.4vw;
  position: relative;
}

.banner-content-wrapper {
  position: absolute;
  top: 50%;
  left: 28%;
  transform: translate(-50%, -50%);
  padding: 0 20%;
}

.banner-content-wrapper h1 {
  color: #fff;
  margin-bottom: 10%;
}

.banner-content-wrapper h1::after {
  content: "";
  position: absolute;
  left: 43%;
  top: 55%;
  transform: translate(-50%, -50%);
  width: 30%;
  height: 5px;
  background-color: #a9c84d;
  border-radius: 5px;
  border: medium none currentColor;
  border: initial;
}
.banner-content-wrapper h1 span {
  font-weight: 700;
}

.custm-txt-l {
  color: var(--yellow);
}

.custm-txt-p {
  color: var(--dPink);
}

.banner-content-wrapper p {
  color: #fff;
  font-size: 24px;
}

.stem-btn {
  border: 2px solid var(--dBlue);
  background-color: transparent;
  border-radius: 25px;
  font-weight: 600;
  padding: 5px 40px;
}

.ss-sub-head p {
  color: var(--dBlue);
  font-size: 24px;
}

.ss-sub-head p span {
  font-weight: 700;
}

/* Tab Customisation  */
.stem-shop-tab {
  column-gap: 0px;
  border: 2px solid var(--dPink);
  background-color: transparent;
  border-radius: 50px;
  margin: 0 auto;
  width: 60%;
}

.stem-shop-tab .active {
  background-color: var(--dPink) !important;
}

.stem-shop-tab .active:first-child {
  width: 50% !important;
  border-radius: 50px 0 0 50px !important;
}

.stem-shop-tab .active:nth-child(2) {
  width: 50% !important;
  border-radius: 0px !important;
}

.stem-shop-tab .active:last-child {
  width: 50% !important;
  border-radius: 0 50px 50px 0px !important;
}

.stem-shop-tab li {
  width: 50% !important;
}

.stem-tab-wrapper {
  padding: 5% 0%;
}
.stem-shop-tab li:nth-child(2) {
  border-left: 2px solid var(--dPink);
  border-right: 2px solid var(--dPink);
}

/* Parenting Tips Component  */
.blog-sec-head h2 span {
  color: var(--dBlue);
}

.blog-slider {
  background-color: #fff8e6 !important;
}

.blog-pink-head h3 {
  color: var(--dPink);
  font-size: 22px;
}

.blogs-card-slider .owl-nav .owl-next {
  color: var(--dBlue) !important;
}

.owl-theme .owl-nav [class*="owl-"]:hover {
  color: #000;
}

.price-wrapper p {
  color: #000 !important;
}

.rating-section {
  color: #000;
}

.blog-pink-head h3 a {
  color: var(--dPink);
}

@media (max-width: 1024px) {
  .stem-banner {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }

  .banner-content-wrapper h1 {
    margin-bottom: 5%;
    font-size: 26px;
  }

  .banner-content-wrapper {
    top: 50%;
    left: 53%;
    width: auto;
    width: initial;
    transform: translate(-95%, -50%);
    padding: 0;
    padding: 0 5%;
  }

  .banner-content-wrapper h1::after {
    left: 10%;
    bottom: 49%;
    width: 45%;
  }

  .banner-content-wrapper p {
    color: #fff;
    font-size: 18px;
  }

  .stem-product-card {
    height: 520px;
  }
}

@media (max-width: 576px) {
  .stem-banner {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 62vh;
  }
  .banner-content-wrapper {
    top: 30%;
    left: 30%;
    transform: translate(-35%, -50%);
    padding: 0;
    padding: initial;
  }

  .banner-content-wrapper h1 {
    margin-bottom: 10%;
    font-size: 24px;
  }

  .banner-content-wrapper h1::after {
    left: 0%;
    bottom: 56%;
    width: 70%;
  }

  .banner-content-wrapper p {
    font-size: 16px;
  }

  .ss-sub-head p {
    font-size: 20px;
  }

  .stem-shop-tab {
    margin: 0 auto;
    width: 90%;
  }

  .stem-shop-tab li {
    padding: 10px 0;
  }

  .stem-product-card {
    height: 470px;
  }

  .gift-cards-slider .owl-dots .owl-dot span {
    width: 2rem;
  }

  .ss-lm-btn .btn {
    padding: 5px 25px;
    margin-top: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/stem-shop/StemShop.css"],"names":[],"mappings":"AAAA;EACE,yDAA4E;EAC5E,wBAAwB;EACxB,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,8BAA8B;EAC9B,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,yDAA4E;EAC9E;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,SAAS;IACT,WAAW;IACX,cAAc;IACd,gCAAgC;IAChC,UAAU;IACV,aAAa;EACf;;EAEA;IACE,SAAS;IACT,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,yDAAyE;IACzE,YAAY;EACd;EACA;IACE,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAc;IAAd,gBAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":[".stem-banner {\n  background-image: url(\"../../../public/images/stem/stem-banner-maritus.png\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  height: 33.4vw;\n  position: relative;\n}\n\n.banner-content-wrapper {\n  position: absolute;\n  top: 50%;\n  left: 28%;\n  transform: translate(-50%, -50%);\n  padding: 0 20%;\n}\n\n.banner-content-wrapper h1 {\n  color: #fff;\n  margin-bottom: 10%;\n}\n\n.banner-content-wrapper h1::after {\n  content: \"\";\n  position: absolute;\n  left: 43%;\n  top: 55%;\n  transform: translate(-50%, -50%);\n  width: 30%;\n  height: 5px;\n  background-color: #a9c84d;\n  border-radius: 5px;\n  border: medium none currentColor;\n  border: initial;\n}\n.banner-content-wrapper h1 span {\n  font-weight: 700;\n}\n\n.custm-txt-l {\n  color: var(--yellow);\n}\n\n.custm-txt-p {\n  color: var(--dPink);\n}\n\n.banner-content-wrapper p {\n  color: #fff;\n  font-size: 24px;\n}\n\n.stem-btn {\n  border: 2px solid var(--dBlue);\n  background-color: transparent;\n  border-radius: 25px;\n  font-weight: 600;\n  padding: 5px 40px;\n}\n\n.ss-sub-head p {\n  color: var(--dBlue);\n  font-size: 24px;\n}\n\n.ss-sub-head p span {\n  font-weight: 700;\n}\n\n/* Tab Customisation  */\n.stem-shop-tab {\n  column-gap: 0px;\n  border: 2px solid var(--dPink);\n  background-color: transparent;\n  border-radius: 50px;\n  margin: 0 auto;\n  width: 60%;\n}\n\n.stem-shop-tab .active {\n  background-color: var(--dPink) !important;\n}\n\n.stem-shop-tab .active:first-child {\n  width: 50% !important;\n  border-radius: 50px 0 0 50px !important;\n}\n\n.stem-shop-tab .active:nth-child(2) {\n  width: 50% !important;\n  border-radius: 0px !important;\n}\n\n.stem-shop-tab .active:last-child {\n  width: 50% !important;\n  border-radius: 0 50px 50px 0px !important;\n}\n\n.stem-shop-tab li {\n  width: 50% !important;\n}\n\n.stem-tab-wrapper {\n  padding: 5% 0%;\n}\n.stem-shop-tab li:nth-child(2) {\n  border-left: 2px solid var(--dPink);\n  border-right: 2px solid var(--dPink);\n}\n\n/* Parenting Tips Component  */\n.blog-sec-head h2 span {\n  color: var(--dBlue);\n}\n\n.blog-slider {\n  background-color: #fff8e6 !important;\n}\n\n.blog-pink-head h3 {\n  color: var(--dPink);\n  font-size: 22px;\n}\n\n.blogs-card-slider .owl-nav .owl-next {\n  color: var(--dBlue) !important;\n}\n\n.owl-theme .owl-nav [class*=\"owl-\"]:hover {\n  color: #000;\n}\n\n.price-wrapper p {\n  color: #000 !important;\n}\n\n.rating-section {\n  color: #000;\n}\n\n.blog-pink-head h3 a {\n  color: var(--dPink);\n}\n\n@media (max-width: 1024px) {\n  .stem-banner {\n    background-image: url(\"../../../public/images/stem/stem-banner-maritus.png\");\n  }\n\n  .banner-content-wrapper h1 {\n    margin-bottom: 5%;\n    font-size: 26px;\n  }\n\n  .banner-content-wrapper {\n    top: 50%;\n    left: 53%;\n    width: auto;\n    width: initial;\n    transform: translate(-95%, -50%);\n    padding: 0;\n    padding: 0 5%;\n  }\n\n  .banner-content-wrapper h1::after {\n    left: 10%;\n    bottom: 49%;\n    width: 45%;\n  }\n\n  .banner-content-wrapper p {\n    color: #fff;\n    font-size: 18px;\n  }\n\n  .stem-product-card {\n    height: 520px;\n  }\n}\n\n@media (max-width: 576px) {\n  .stem-banner {\n    background-image: url(\"../../../public/images/stem/STEM-Shop-mobile.png\");\n    height: 62vh;\n  }\n  .banner-content-wrapper {\n    top: 30%;\n    left: 30%;\n    transform: translate(-35%, -50%);\n    padding: unset;\n  }\n\n  .banner-content-wrapper h1 {\n    margin-bottom: 10%;\n    font-size: 24px;\n  }\n\n  .banner-content-wrapper h1::after {\n    left: 0%;\n    bottom: 56%;\n    width: 70%;\n  }\n\n  .banner-content-wrapper p {\n    font-size: 16px;\n  }\n\n  .ss-sub-head p {\n    font-size: 20px;\n  }\n\n  .stem-shop-tab {\n    margin: 0 auto;\n    width: 90%;\n  }\n\n  .stem-shop-tab li {\n    padding: 10px 0;\n  }\n\n  .stem-product-card {\n    height: 470px;\n  }\n\n  .gift-cards-slider .owl-dots .owl-dot span {\n    width: 2rem;\n  }\n\n  .ss-lm-btn .btn {\n    padding: 5px 25px;\n    margin-top: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
